import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SignupComponent } from './../signup/signup.component';
import { MatDialog, MatDrawer } from '@angular/material';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ResetPasswordEnterMobileComponent } from '../reset-password-enter-mobile/reset-password-enter-mobile.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  constructor(private authService: AuthService, private dialog: MatDialog) { }

  onLogin(form: NgForm) {
    const data = new FormData();
    data.append('mobile', `+94${form.value.mobile}`);
    data.append('password', form.value.password);
    this.authService.userLogin(data);
  }

  onSignup() {
    this.dialog.open(SignupComponent, { disableClose: true });
  }

  onResetPassword() {
    this.dialog.open(ResetPasswordEnterMobileComponent, { disableClose: true })
  }
}
